import styles from "./style.module.scss";
import { translate } from "@helpers/translationObjectFormatter";
import { useQuery } from "@tanstack/react-query";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import TicIcon from "@components/shared/bestBuyers/icons/TicIcon";
import XIcon from "@components/shared/bestBuyers/icons/XIcon";
import { GQLOfferFeatures } from "@gql/types/gql";
export default function ProsConsList({ list }: { list?: GQLOfferFeatures[] }) {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    return (
        <>
            {list ? (
                <div>
                    <h2 className="font-bold lg:text-lg lg:leading-8  text-base leading-7 ">
                        {list[0].type
                            ? list[0].type === "pros"
                                ? translate(
                                      translations,
                                      "several_general_prosWord",
                                  )
                                : translate(
                                      translations,
                                      "several_general_consWord",
                                  )
                            : "Pros/Cons"}
                    </h2>
                    <div
                        className={`${styles["borderStyle"]} lg:mt-2 mt-3 pt-7 `}
                    >
                        {list?.map((listItem, index) => {
                            return (
                                <div
                                    key={index}
                                    className={`leading-5 ${styles["paragraphColor"]} text-sm lg:text-lg rtl:text-base flex items-baseline pb-3 lg:gap-3 gap-4 max-w-sm lg:ml-0 ml-4`}
                                >
                                    <div className="pt-2">
                                        {listItem.type === "pros" ? (
                                            <TicIcon color="#F9BB21" />
                                        ) : (
                                            <XIcon color="#F9BB21" />
                                        )}
                                    </div>
                                    <div
                                        className={`ltr:leading-5 rtl:leading-[26px] ${styles["paragraphColor"]}`}
                                    >
                                        {listItem.description}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ) : (
                <></>
            )}
        </>
    );
}
